export const USER_ACTION='user_action'
export const COMMAND_CENTER_ACTION='command_center_action'
export const POWER_ACTION='power_action'
export const NFC_ACTION='nfc_action'